export default "__VITE_ASSET__CUC_pDw7__"